import React from 'react';
import { Check } from 'lucide-react';

const STEPS = [
  { id: 1, label: 'Release Type', sublabel: 'Single / EP / Album' },
  { id: 2, label: 'Audio Upload', sublabel: '44.1 kHz WAV' },
  { id: 3, label: 'Track Details', sublabel: 'Metadata & Credits' },
  { id: 4, label: 'Cover Art', sublabel: '3000x3000px 1:1' },
  { id: 5, label: 'Review & Submit', sublabel: 'Verification' },
];

export default function DistributionStepper({ currentStep, completedSteps, onStepClick }) {
  if (currentStep > 5) return null; // Success step hides stepper

  return (
    <div className="dist-stepper-container" aria-label="Distribution workflow progress">
      <div className="dist-stepper-track">
        {STEPS.map((step, idx) => {
          const isCompleted = completedSteps.includes(step.id);
          const isActive = currentStep === step.id;
          const isClickable = isCompleted || step.id <= Math.max(...completedSteps, 1);

          return (
            <React.Fragment key={step.id}>
              <button
                type="button"
                className={`dist-step-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isClickable ? 'clickable' : ''}`}
                onClick={() => isClickable && onStepClick(step.id)}
                disabled={!isClickable}
                aria-current={isActive ? 'step' : undefined}
                aria-label={`Step ${step.id}: ${step.label} (${step.sublabel})`}
              >
                <div className="dist-step-circle">
                  {isCompleted && !isActive ? <Check size={14} strokeWidth={3} /> : step.id}
                </div>
                <div className="dist-step-label-group">
                  <span className="dist-step-label">{step.label}</span>
                  <span className="dist-step-sublabel">{step.sublabel}</span>
                </div>
              </button>

              {idx < STEPS.length - 1 && (
                <div className={`dist-step-divider ${completedSteps.includes(step.id) ? 'filled' : ''}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
